import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p4_under_utilized archetype (real metrics, fake identity).
export const bAdvP4UnderUtilized: FaireBrandEntity = {
  token: "b_adv_p4_under_utilized",
  type: "brand",
  name: "Alto Mixer Co.",
  description: "Craft cocktail mixer cubes and bar kits",
  location: "Denver, CO",
  rating: 4.8,
  minimumOrderDollars: 200,
  tags: ["cocktail", "mixers", "gifts"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
